import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ConfirmModal from '../../ConfirmModal/ConfirmModal.jsx'

function Preferences(props) {
  const {
    userSubscriptionProfile,
    storageProfile,
    handleUpdateProfile,
    handleUnsubscribeAll,
  } = props

  const [unsubscribeInProcess, setUnsubscribeInProcess] = useState(false)

  const handleMarketingCheckboxClick = (event) => {
    const checked = event.target.checked !== undefined && event.target.checked

    const userProfile = {
      contactID: userSubscriptionProfile.contactID,
      firstName: storageProfile.firstName,
      lastName: storageProfile.lastName,
      emailId: storageProfile.emailId,
      role: userSubscriptionProfile.role,
      subscriptionsEnabled: checked ? 'Y' : 'N',
      emailOptoutEnabled: userSubscriptionProfile.emailOptoutEnabled,
    }

    handleUpdateProfile(userProfile, true)
  }

  const handleUnsubscribeAllClick = (event) => {
    const checked = event.target.checked !== undefined && event.target.checked
    if (!checked) {
      setUnsubscribeInProcess(true)
    } else {
      const userProfile = {
        contactID: userSubscriptionProfile.contactID,
        firstName: storageProfile.firstName,
        lastName: storageProfile.lastName,
        emailId: storageProfile.emailId,
        role: userSubscriptionProfile.role,
        subscriptionsEnabled: userSubscriptionProfile.subscriptionsEnabled,
        emailOptoutEnabled: 'N',
      }
      handleUpdateProfile(userProfile, true)
    }
  }

  const unsubscribeAllHandler = (e, confirmed) => {
    if (!confirmed) {
      setUnsubscribeInProcess(true)
    } else {
      e.preventDefault()
      e.stopPropagation()

      if (confirmed === 1) {
        handleUnsubscribeAll()
      }
      setUnsubscribeInProcess(false)
    }
  }

  return (
    <React.Fragment>
      <hr className="Rule u-textColorBrand" />
      <div
        id="Preferences"
        className="Card u-lg-sizeConstrained u-marginBottom4gu u-bgColorWhite u-sm-paddingHoriz3gu u-sm-paddingVert6gu u-sm-marginBottom6gu"
      >
        <h2 className="u-marginBottom1gu">Preferences</h2>
        <div className="Grid Grid--withGutter u-paddingHoriz1gu u-paddingVert3gu">
          <div className="u-sizeFull u-marginTop1gu">
            <input
              id={'marketingCheckbox'}
              checked={userSubscriptionProfile.subscriptionsEnabled === 'Y'}
              onChange={handleMarketingCheckboxClick}
              type="checkbox"
              className="Subscription-checkbox"
            ></input>
            <label htmlFor={'marketingCheckbox'}>
              <h4 className="u-marginLeft2gu u-marginRight2gu">
                Marketing Communications
              </h4>
            </label>
            <p className="u-marginTop1gu u-marginLeft5gu">
              In addition to my subscriptions, I’d like to receive alerts about
              new products, programs and other newsworthy topics from Columbia
              Threadneedle.
            </p>
          </div>
          <div className="u-sizeFull u-marginTop1gu">
            <input
              id={'unsubscribeAllCheckbox'}
              checked={
                userSubscriptionProfile.emailOptoutEnabled === 'N' ||
                userSubscriptionProfile.emailOptoutEnabled === null
              }
              onChange={handleUnsubscribeAllClick}
              type="checkbox"
              className="Subscription-checkbox"
            ></input>
            <label htmlFor={'unsubscribeAllCheckbox'}>
              <h4 className="u-marginLeft2gu u-marginRight2gu">
                All Columbia Threadneedle Communications
              </h4>
            </label>
            <p className="u-marginTop1gu u-marginLeft5gu">
              I don&apos;t want to miss a thing. Keep me informed by sending all
              Columbia Threadneedle Investments communications, beyond marketing
              and sales messages.
            </p>
          </div>
        </div>
      </div>

      {unsubscribeInProcess && (
        <ConfirmModal
          title="Please Confirm"
          text="Are you sure you want to unsubscribe from receiving all communications from Columbia Threadneedle Investments?"
          unsubscribeAllHandler={unsubscribeAllHandler}
        />
      )}
    </React.Fragment>
  )
}

Preferences.propTypes = {
  userSubscriptionProfile: PropTypes.object.isRequired,
  storageProfile: PropTypes.object.isRequired,
  handleUpdateProfile: PropTypes.func.isRequired,
  handleUnsubscribeAll: PropTypes.func.isRequired,
}

export default Preferences
